import React, { useState, useEffect, useRef } from "react";
import { AddToolTip, FormControlSearch } from "../../../components";
import { InputGroup, Image } from "react-bootstrap";
import { Field } from "formik";
import { FieldInputNumber } from "../../../components";
import { useDeepEffect } from "../../../abstracts";
import { get } from "lodash";

function InvestmentHierarchy(props) {
  const {
    fields,
    withdrawalRequestId,
    style = {},
    className = "",
    handleChange,
    sourceSelected,
    InvestDetails,
    outerValues,
    values,
    getSourceType,
    getSourceSubCategory,
    getSourceCategory,
    setFieldValue,
    selectSourceIndex,
    filteredSourceBalances,
    ...rest
  } = props;
  const [searchString, setSearchString] = useState("");
  const both = 1;
  const [scrollheight, setScrollHeight] = useState("");
  const investment =
    values[fields.hierarchyCalculationMethod]?.length === 2
      ? sourceSelected?.sourceInvestmentBalances
      : InvestDetails;

  let initialInvestmentHierarchyParsedDetails = [];

  if (
    values?.hierarchyCalculationMethod?.length === 1 &&
    values?.hierarchyCalculationMethod.includes(2)
  ) {
    initialInvestmentHierarchyParsedDetails = [].concat(
      ...get(values, "sourceHierarchyDetails", []).map(
        (_) => _.investmentHierarchies
      )
    );

    initialInvestmentHierarchyParsedDetails = InvestDetails?.map((val, ind) => {
      const investmentFound = initialInvestmentHierarchyParsedDetails.find(
        (_) => _.investmentId === parseInt(val.investmentId)
      );
      return {
        investmentId: parseInt(val.investmentId),
        hierarchyNumber: get(investmentFound, "hierarchyNumber", ""),
      };
    });
  }
  useEffect(() => {
    if (values[fields.hierarchyCalculationMethod]?.length == 2) {
      setScrollHeight("220px");
    } else {
      setScrollHeight("300px");
    }
  }, [setScrollHeight]);
  return (
    <div className="sourceHierarchy" style={{ width: "500px" }}>
      <div className="d-flex flex-column sourceHierarchy_HeaderFont">
        Investment Hierarchy
        {values[fields.hierarchyCalculationMethod]?.length === 2 && (
          <div className="sourceHierarchy_Card ">
            <div className="d-flex space-between">
              <div>
                <div className="sourceAndInvestment_HeaderFont">
                  Source Name
                </div>
                <div className="sourceAndInvestment_BodyFont">
                  {getSourceType(sourceSelected?.sourceType)}{" "}
                  {getSourceCategory(sourceSelected?.sourceCategory)} -{" "}
                  {getSourceSubCategory(sourceSelected?.sourceSubCategory)}
                </div>
              </div>
              <div>
                <div
                  className="sourceAndInvestment_HeaderFont"
                  style={{ marginRight: "20px" }}
                >
                  Balance
                </div>
                <div
                  className="sourceAndInvestment_BodyFont"
                  style={{ marginRight: "20px" }}
                >
                  {sourceSelected.sourceEmployeeMap?.accountBalance
                    ?.toFixed(2)
                    .toString()?.length > 8 ? (
                    <AddToolTip
                      name={sourceSelected.sourceEmployeeMap?.accountBalance?.toFixed(
                        2
                      )}
                    >
                      ${" "}
                      {sourceSelected.sourceEmployeeMap?.accountBalance
                        ?.toFixed(2)
                        .toString()
                        .slice(0, 8)}
                      ...
                    </AddToolTip>
                  ) : (
                    <>
                      ${" "}
                      {sourceSelected.sourceEmployeeMap?.accountBalance?.toFixed(
                        2
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="search-bar-Hierarchy">
          <InputGroup>
            <InputGroup.Prepend style={{ marginTop: "20px" }}>
              <InputGroup.Text
                className="plan-search-button"
                style={{ border: "1px solid #bdbdbd", borderRight: "white" }}
              >
                <Image src="/assets/icons/svg/search.svg" width="14px" />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <FormControlSearch
              size="sm"
              id="plan-search-box"
              className="plan-search-box"
              type="search"
              autoComplete="off"
              placeholder="Search Investment"
              onChange={(e) => setSearchString(e.target.value)}
              style={{ borderLeft: "white" }}
            />
          </InputGroup>
        </div>
        <div className="sourceHierarchy_BodyFont" style={{ marginTop: "7px" }}>
          {
            investment?.filter((_) => {
              return _.investmentName
                .toLowerCase()
                .includes(searchString.toLowerCase());
            }).length
          }{" "}
          investments found
        </div>
        <div className="investHierarchy_HeaderFont d-flex ">
          <div className="Table_heading1">Investments & Category</div>
          <div className="Table_heading2"> Balance</div>
          <div className="Table_heading3"> Rate of return</div>
          <div className="Table_heading4"> Hierarchy</div>
        </div>
        <div style={{ overflow: "scroll", height: scrollheight }}>
          {investment
            ?.filter((_) => {
              return _.investmentName
                .toLowerCase()
                .includes(searchString.toLowerCase());
            })
            .map((val, i) => {
              return (
                <div className="investHierarchy_Card d-flex">
                  <div style={{ columnWidth: "600px" }}>
                    {val.investmentName?.length > 15 ? (
                      <div className="investHierarchy_Card_Headerfont">
                        <AddToolTip name={val.investmentName}>
                          {val.investmentName.slice(0, 15)}...
                        </AddToolTip>{" "}
                      </div>
                    ) : (
                      <div className="investHierarchy_Card_Headerfont">
                        {val.investmentName}
                      </div>
                    )}
                    <div className="investHierarchy_BodyFont">-</div>
                  </div>
                  {values[fields.hierarchyCalculationMethod]?.length === 2 ? (
                    val.sourceEmployeeInvestmentMap?.accountBalance
                      ?.toFixed(2)
                      .toString()?.length > 8 ? (
                      <div className="investHierarchy_Card_Bodyfont">
                        <AddToolTip
                          name={val.sourceEmployeeInvestmentMap?.accountBalance?.toFixed(
                            2
                          )}
                        >
                          ${" "}
                          {val.sourceEmployeeInvestmentMap?.accountBalance
                            ?.toFixed(2)
                            .toString()
                            .slice(0, 8)}
                          ...
                        </AddToolTip>
                      </div>
                    ) : (
                      <div className="investHierarchy_Card_Bodyfont">
                        ${" "}
                        {val.sourceEmployeeInvestmentMap?.accountBalance?.toFixed(
                          2
                        )}
                      </div>
                    )
                  ) : val.totalAvailableBalance?.toFixed(2).toString()?.length >
                    8 ? (
                    <div className="investHierarchy_Card_Bodyfont">
                      <AddToolTip name={val.totalAvailableBalance?.toFixed(2)}>
                        ${" "}
                        {val.totalAvailableBalance
                          ?.toFixed(2)
                          .toString()
                          .slice(0, 8)}
                        ...
                      </AddToolTip>
                    </div>
                  ) : (
                    <div className="investHierarchy_Card_Bodyfont">
                      $ {val.totalAvailableBalance?.toFixed(2)}
                    </div>
                  )}
                  <div className="investHierarchy_Card_Bodyfont">-</div>
                  {values[fields.hierarchyCalculationMethod]?.length === 1 &&
                  values[fields.hierarchyCalculationMethod]?.[0] === 2 ? (
                    <div
                      style={{
                        marginRight: "15px",
                        marginBottom: "auto",
                        marginTop: "12px",
                      }}
                    >
                      <Field
                        size="xxs"
                        isRequired
                        name={`${fields.investmentHierarchies}.${i}.${fields.hierarchyNumber}`}
                        type="number"
                        autoComplete="off"
                        value={get(
                          initialInvestmentHierarchyParsedDetails,
                          `${i}.${fields.hierarchyNumber}`,
                          ""
                        )}
                        onChange={(event) => {
                          const value = parseInt(event.target.value);
                          const sourceHierarchyDetails = filteredSourceBalances.map(
                            (sou, ind) => {
                              return {
                                sourceId: sou.sourceId,
                                hierarchyNumber: 0,
                                investmentHierarchies: sou.sourceInvestmentBalances.map(
                                  (i, invIndex) => {
                                    return {
                                      investmentId: i.investmentId,
                                      hierarchyNumber:
                                        i.investmentId ===
                                        parseInt(val.investmentId)
                                          ? value
                                          : get(
                                              values,
                                              `${fields.sourceHierarchyDetails}.${ind}.investmentHierarchies.${invIndex}.hierarchyNumber`
                                            ),
                                    };
                                  }
                                ),
                              };
                            }
                          );
                          setFieldValue(
                            fields.sourceHierarchyDetails,
                            sourceHierarchyDetails
                          );
                        }}
                        validate={(value) => {
                          return [undefined, null, ""].includes(value)
                            ? "Required"
                            : undefined;
                        }}
                        component={FieldInputNumber}
                        min={0}
                        max={999}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        marginRight: "15px",
                        marginBottom: "auto",
                        marginTop: "12px",
                      }}
                    >
                      <Field
                        size="xxs"
                        isRequired
                        name={`${fields.sourceHierarchyDetails}.${selectSourceIndex}.investmentHierarchies.${i}.${fields.hierarchyNumber}`}
                        type="number"
                        autoComplete="off"
                        value={get(
                          values,
                          `${fields.sourceHierarchyDetails}.${selectSourceIndex}.investmentHierarchies.${i}.${fields.hierarchyNumber}`
                        )}
                        onChange={(event) => {
                          setFieldValue(
                            `${fields.sourceHierarchyDetails}.${selectSourceIndex}.investmentHierarchies.${i}.${fields.hierarchyNumber}`,
                            parseInt(event.target.value)
                          );
                        }}
                        component={FieldInputNumber}
                        validate={(value) => {
                          return [undefined, null, ""].includes(value)
                            ? "Required"
                            : undefined;
                        }}
                        min={0}
                        max={999}
                      />
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export default InvestmentHierarchy;
